<div class="login-page">
  <div class="login-form">
    <mat-card>
      <mat-card-content class="card-warp">
        <div *ngIf="selectedCmp(); else noMethod" [ngComponentOutlet]="selectedCmp()"
          [ngComponentOutletInjector]="childInjector()" [ngComponentOutletInputs]="{ formControl: form }">
        </div>

        <button class="btn" [ngClass]="{ disabled: !form.valid }" (click)="onSubmit()" [disabled]="!form.valid">
          <div translate>login.connect</div>
        </button>

        <ng-template #noMethod>
          <p class="no-method-text">לא הוגדרה שיטת התחברות נתמכת.</p>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <div class="error" *ngIf="errorKey$()">
      {{ 'login.errors.' + errorKey$() | translate }}
    </div>

    <div class="powered-by">

      <div class="client-logo-row">

        <img class="client-logo" [src]="'/assets/images/header/questionnaireSite-' + client + '-logo.svg'"
          alt="Client logo" />
        <p class="powered-title">{{ title }}</p>

      </div>

      <div class="sqlink-logo-row" *ngIf="client === 'directq'">
        <img class="sqlink-logo" src="/assets/images/header/sqlink-logo-dark.svg" alt="SQLink logo" />
      </div>

    </div>
  </div>
</div>